import { Home } from '@/modules/home';

export default function Page() {
  return <Home />;
}
